import Vue from "vue";
import { getCookie } from "../../../../ask/cookiejs";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue';
import senderAddrBox from '../../../../components/userCenter/public/senderAddrBox.vue';
import receiveAddrBox from '../../../../components/userCenter/public/receiveAddrBox.vue';
import productInfoBox from '../../../../components/userCenter/public/productInfoBox.vue';

export default {
  components: { menberMenu, senderAddrBox, receiveAddrBox, productInfoBox },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      titNames: "My Booking",
      titUrls: ",",

      airDelegateList: [], //列表

      //新增委托书弹框
      addPowerAttorneyBox: false,

      chkedSender: false,//加入到发件人地址库
      chkedRecive: false, //加入到收件人地址库
      chkedReciveInfo: false, //同收件人

      ContactInfoTitle: '', //新增空运委托书
      isDisaed: false,//是否禁止改写发件人公司名
      //--------收发件人信息
      ContactInfo: {
        Id: "",//
        SenderName: "", //发件人姓名
        SenderCompany: "",
        SenderTelephone: "",
        SenderAddress: "",
        ReceiveName: "",//收件人姓名
        ReceiveCompany: "",
        ReceiveTelephone: "",
        ReceiveAddress: "",
        NofityName: "",//通知人姓名
        NotifyCompany: "",
        NotifyTelephone: "",
        NotifyAddress: "",
        SenderTaxNO: "",//发件人税号
        ReceiveTaxNO: "",//收件人税号
        NotifyTaxNO: "",//通知人税号
        ShippingMark: '',//唛头
        GoodsName: '',//货物品名
      },

      userType: 0,

      isCode: null, //判断是收件人还是通知人地址库

    }
  },

  created() { //创建后
    this.getDelegateApi();
  },
  mounted() { //载入dom后周期函数
    this.getValidation(); //验证调取
    this.userType = JSON.parse(
      sessionStorage.getItem("customerInfos")
    ).CustomerOwnerType;
    console.log(this.userType, "this.userType");
  },
  watch: {//监听函数变化

  },
  computed: {//计算属性

  },

  //方法
  methods: {
    //验证调取
    getValidation() {
      $('#AddrEditValidation').validationEngine();
    },
    getCheckForm() {
      return $("#AddrEditValidation").validationEngine('validate');
      //$('#form1').validationEngine('validate')
    },
    //查询委托书列表接口
    getDelegateApi() {
      let that = this;
      this.api.param = {
      };
      this.api.url = this.$api04 + "/Air/api/AirDelegate/GetDelegateInfoList"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.airDelegateList = res.Results
        }
      })
    },
    //新增委托书
    clkAddBtn() {

      this.ContactInfoTitle = 'Making a new booking form', //空运委托书弹框标题
        this.addPowerAttorneyBox = true
    },
    //编辑
    clkEdit(item) {
      this.isDisaed = true
      this.ContactInfoTitle = 'Edit booking form' //空运委托书弹框标题
      this.addPowerAttorneyBox = true

      //this.ContactInfo=JSON.stringify(item)
      this.ContactInfo.SenderName = item.SenderName //发件人姓名
      this.ContactInfo.SenderCompany = item.SenderCompany
      this.ContactInfo.SenderTelephone = item.SenderTelephone
      this.ContactInfo.SenderAddress = item.SenderAddress
      this.ContactInfo.ReceiveName = item.ReceiveName//收件人姓名
      this.ContactInfo.ReceiveCompany = item.ReceiveCompany
      this.ContactInfo.ReceiveTelephone = item.ReceiveTelephone
      this.ContactInfo.ReceiveAddress = item.ReceiveAddress
      this.ContactInfo.NofityName = item.NofityName//通知人姓名
      this.ContactInfo.NotifyCompany = item.NotifyCompany
      this.ContactInfo.NotifyTelephone = item.NotifyTelephone
      this.ContactInfo.NotifyAddress = item.NotifyAddress
      this.ContactInfo.SenderTaxNO = item.SenderTaxNO//发件人税号
      this.ContactInfo.ReceiveTaxNO = item.ReceiveTaxNO//收件人税号
      this.ContactInfo.NotifyTaxNO = item.NotifyTaxNO//通知人税号
      this.ContactInfo.ShippingMark = item.ShippingMark//唛头
      this.ContactInfo.GoodsName = item.GoodsName//货物品名
      //console.log('this.ContactInfo ' +  JSON.stringify(this.ContactInfo));                  
    },

    //删除
    clkDel(code) {
      //console.log('item  '+JSON.stringify(code))
      this.$confirm('Are you sure you want to delete this booking form?', '', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        showCancelButton: true,//去掉取消按钮
        showClose: true,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.delApi(code);
      }).catch(() => {

      });
      return false
    },
    delApi(id) {
      let that = this;
      this.api.param = {
        Id: id,
        Lang: 1, //系统版本0:中文版 1:英文版(默认0)
      };
      this.api.url = this.$api03 + "/api/TradeCustomer/AirDelegate/DeleteDelegate"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.getDelegateApi();
        } else {
          this.$confirm('failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return fals
        }

      })
    },

    //----------------弹框--------------------------///

    //关闭弹框按钮
    clkClose() {
      this.isDisaed = false
      this.addPowerAttorneyBox = false
      let ContactInfoObj = {
        SenderName: "", //发件人姓名
        SenderCompany: "",
        SenderTelephone: "",
        SenderAddress: "",
        ReceiveName: "",//收件人姓名
        ReceiveCompany: "",
        ReceiveTelephone: "",
        ReceiveAddress: "",
        NofityName: "",//通知人姓名
        NotifyCompany: "",
        NotifyTelephone: "",
        NotifyAddress: "",
        SenderTaxNO: "",//发件人税号
        ReceiveTaxNO: "",//收件人税号
        NotifyTaxNO: "",//通知人税号
        ShippingMark: '',//唛头
        GoodsName: '',//货物品名
      };
      this.chkedSender = false
      this.chkedRecive = false
      this.chkedReciveInfo = false
      this.ContactInfo = ContactInfoObj
      //this.$refs.ruleForm.resetFields();
      //console.log('sdsd' +  JSON.stringify(this.ContactInfo))

      $('#AddrEditValidation').validationEngine("hide");//隐藏错误提示

    },

    //点击发件地址库
    clkAddrBox() {
      this.$refs.senderAddr.clkDialog()
    },
    //发件人地址库点击选择按钮
    showMsgSender(msg) {
      //发件人地址库选择按钮赋值
      this.ContactInfo.SenderName = msg.Address_Name
      this.ContactInfo.SenderCompany = msg.company
      this.ContactInfo.SenderTelephone = msg.Address_Tel
      this.ContactInfo.SenderAddress = msg.Address_Street
      this.ContactInfo.SenderTaxNO = ''
    },
    //收件地址库
    clkReceiveAddrBox(code) {
      this.isCode = code
      this.$refs.receiveBox.clkDialog();
    },
    //收件人地址库点击选择按钮
    showMsgReceive(msg) {
      if (this.isCode == 1) {
        //收件人地址库选择按钮赋值
        this.ContactInfo.ReceiveName = msg.Address_Name
        this.ContactInfo.ReceiveCompany = msg.company
        this.ContactInfo.ReceiveTelephone = msg.Address_Tel
        this.ContactInfo.ReceiveAddress = msg.Address_Street
        this.ContactInfo.ReceiveTaxNO = ''
      } else if (this.isCode == 2) {
        //通知人地址库选择按钮赋值
        this.ContactInfo.NofityName = msg.Address_Name
        this.ContactInfo.NotifyCompany = msg.company
        this.ContactInfo.NotifyTelephone = msg.Address_Tel
        this.ContactInfo.NotifyAddress = msg.Address_Street
        this.ContactInfo.NotifyTaxNO = ''
      }
    },
    //同收件人信息
    chgReceiveInfo() {
      if (this.chkedReciveInfo == true) {
        this.ContactInfo.NofityName = this.ContactInfo.ReceiveName
        this.ContactInfo.NotifyCompany = this.ContactInfo.ReceiveCompany
        this.ContactInfo.NotifyTelephone = this.ContactInfo.ReceiveTelephone
        this.ContactInfo.NotifyAddress = this.ContactInfo.ReceiveAddress
        this.ContactInfo.NotifyTaxNO = this.ContactInfo.ReceiveTaxNO
      }
    },
    //----------------产品信息地址库弹框
    clkProductBox() {
      this.$refs.productBox.clkDialog();
    },
    //-产品信息库弹框选择按钮
    showMsgProduct(msg) {
      let nameEnObj = ''
      let nameEnArr = []
      msg.forEach(e => {
        nameEnArr.push(e.EnglishName)
      })
      nameEnObj = nameEnArr.join(',')
      this.ContactInfo.GoodsName = nameEnObj
    },
    //弹框确定按钮
    clickForm() {
      //验证方法
      let isCheck = this.getCheckForm();
      if (!isCheck) {
        return false
      } else {
        if (this.ContactInfo.Id > 0) {
          this.EditDelegatListeApi();
        } else {
          this.AddDelegatListeApi(); //新增数据接口
        }

        this.clkClose(); //关闭弹框
      }
    },

    //新增空运委托书确定接口
    AddDelegatListeApi() {
      let that = this;
      this.api.param = {
        "Id": '',
        "DelegateName": this.ContactInfo.SenderCompany,
        "SenderName": this.ContactInfo.SenderName,
        "SenderCompany": this.ContactInfo.SenderCompany,
        "SenderTelephone": this.ContactInfo.SenderTelephone,
        "SenderAddress": this.ContactInfo.SenderAddress,
        "SenderTaxNO": this.ContactInfo.SenderTaxNO,
        "ReceiveName": this.ContactInfo.ReceiveName,
        "ReceiveCompany": this.ContactInfo.ReceiveCompany,
        "ReceiveTelephone": this.ContactInfo.ReceiveTelephone,
        "ReceiveAddress": this.ContactInfo.ReceiveAddress,
        "ReceiveTaxNO": this.ContactInfo.ReceiveTaxNO,
        "NofityName": this.ContactInfo.NofityName,
        "NotifyCompany": this.ContactInfo.NotifyCompany,
        "NotifyTelephone": this.ContactInfo.NotifyTelephone,
        "NotifyAddress": this.ContactInfo.NotifyAddress,
        "NotifyTaxNO": this.ContactInfo.NotifyTaxNO,
        "ShippingMark": this.userType == 2 || this.userType == 3 ? 'According to the booking' : this.ContactInfo.ShippingMark,
        "GoodsName": this.userType == 2 || this.userType == 3 ? 'According to the booking' : this.ContactInfo.GoodsName,
        IsSendAddToAddr: this.chkedSender, //是否加入发件人地址库
        IsReceiveAddToAddr: this.chkedRecive, //是否加入收件人地址库
        Lang: 1, //系统版本0:中文版 1:英文版(默认0)
      };
      this.api.url = this.$api03 + "/api/TradeCustomer/AirDelegate/InsertDelegate"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.getDelegateApi()
        } else if (res.IsOK == false) {
          that.$confirm('failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false
        }

      })
    },

    ///api/TradeCustomer/AirDelegate/UpdateDelegate
    EditDelegatListeApi() {
      let that = this;
      this.api.param = {
        "Id": this.ContactInfo.Id,
        "DelegateName": this.ContactInfo.SenderCompany,
        "SenderName": this.ContactInfo.SenderName,
        "SenderCompany": this.ContactInfo.SenderCompany,
        "SenderTelephone": this.ContactInfo.SenderTelephone,
        "SenderAddress": this.ContactInfo.SenderAddress,
        "SenderTaxNO": this.ContactInfo.SenderTaxNO,
        "ReceiveName": this.ContactInfo.ReceiveName,
        "ReceiveCompany": this.ContactInfo.ReceiveCompany,
        "ReceiveTelephone": this.ContactInfo.ReceiveTelephone,
        "ReceiveAddress": this.ContactInfo.ReceiveAddress,
        "ReceiveTaxNO": this.ContactInfo.ReceiveTaxNO,
        "NofityName": this.ContactInfo.NofityName,
        "NotifyCompany": this.ContactInfo.NotifyCompany,
        "NotifyTelephone": this.ContactInfo.NotifyTelephone,
        "NotifyAddress": this.ContactInfo.NotifyAddress,
        "NotifyTaxNO": this.ContactInfo.NotifyTaxNO,
        "ShippingMark": this.userType == 2 || this.userType == 3 ? 'According to the booking' : this.ContactInfo.ShippingMark,
        "GoodsName": this.userType == 2 || this.userType == 3 ? 'According to the booking' : this.ContactInfo.GoodsName,
        IsSendAddToAddr: this.chkedSender, //是否加入发件人地址库
        IsReceiveAddToAddr: this.chkedRecive, //是否加入收件人地址库
        Lang: 1, //系统版本0:中文版 1:英文版(默认0)
      };
      this.api.url = this.$api03 + "/api/TradeCustomer/AirDelegate/UpdateDelegate"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.getDelegateApi()
        } else if (res.IsOK == false) {
          that.$confirm('failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false
        }

      })
    },


  }
}


// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/airDelegate.js